// extracted by mini-css-extract-plugin
export default {"allContainer":"ImageGalerie_allContainer__PEg65","faCamera":"ImageGalerie_faCamera__Z6LG5","faXmark":"ImageGalerie_faXmark__2YAKk"};